import { render, staticRenderFns } from "./InspectionHistory.vue?vue&type=template&id=4ac6a03c&"
import script from "./InspectionHistory.vue?vue&type=script&lang=js&"
export * from "./InspectionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports